import { onPageLoaded } from "../imaios-global/imaios-global";

onPageLoaded(() => {
	function setupDropdown(toggle) {
		const toggleId = toggle.id;
		const dropdown = document.querySelector(`[aria-labelledby="${toggleId}"]`);

		toggle
			.parentElement
			.addEventListener('mouseenter', () => {
				setTimeout(() => {
					if (isHover(toggle.parentElement)) {
						openDropDown(toggle, dropdown);
					}
				}, getOpenDelay())
			});
		toggle
			.parentElement
			.addEventListener('mouseout', () => {
				setTimeout(() => {
					if (!isHover(toggle.parentElement)) {
						closeDropDown(toggle);
					}
				}, CLOSE_DELAY);
			})
		toggle.addEventListener('keyup', event => {
			if (!['enter', ' ', 'space'].includes(event.key)) {
				return;
			}
			if (isOpen(toggle)) {
				closeDropDown(toggle);
			} else {
				openDropDown(toggle, dropdown);
			}
		});
		dropdown.addEventListener('animationend', event => {
			if (event.animationName === 'dropdown-slide-up') {
				dropdown.classList.remove(CLOSING_DROPDOWN_CLASS);
			}
		});
	}


	const OPEN_DROPDOWN_CLASS = 'open';
	const CLOSING_DROPDOWN_CLASS = 'closing';
	/**
	 * how long to wait after an element gets hovered if no dropdown is open
	 * @type {number}
	 */
	const COLD_OPEN_DELAY = 500;

	/**
	 * how long to wait after an element gets hover if another dropdown is open
	 */
	const WARMED_UP_OPEN_DELAY = 100;

	const CLOSE_DELAY = 500;

	let activeToggle = null;

	function getOpenDelay() {
		return activeToggle !== null ? WARMED_UP_OPEN_DELAY : COLD_OPEN_DELAY;
	}

	function isOpen(toggle) {
		return activeToggle === toggle;
	}

	/**
	 *
	 * @param {HTMLButtonElement} toggle
	 * @param {HTMLElement} dropdown
	 */
	function openDropDown(toggle, dropdown) {
		if (activeToggle !== null && toggle!==activeToggle) {
			closeDropDown(activeToggle, );
		}
		toggle.setAttribute('aria-expanded', 'true');
		dropdown.classList.add(OPEN_DROPDOWN_CLASS);
		activeToggle = toggle;
	}

	/**
	 *
	 * @param {HTMLButtonElement} toggle
	 */
	function closeDropDown(toggle) {
		if (!isOpen(toggle)) {
			return;
		}
		const dropdown = document.querySelector(`[aria-labelledby="${activeToggle.id}"]`);
		toggle.setAttribute('aria-expanded', 'false');
		dropdown.classList.remove(OPEN_DROPDOWN_CLASS);
		dropdown.classList.add(CLOSING_DROPDOWN_CLASS);
		activeToggle = null;
	}

	function isHover(element) {
		return element.parentElement.querySelector(':hover') === element;
	}

	document
		.querySelectorAll('.mega-dropdown-toggle .nav-link')
		.forEach(setupDropdown)
})
